// src/hooks/usePreferencesModal.ts
import useUiStore from "../store/useUiStore.ts";
import SeriesModal from "../components/Series/SeriesModal.tsx";
import React from "react";
import {useSeriesStore} from "../store/useSeriesStore.ts";

export const useOpenSeriesModal = () => {
  const {seriesNameIdMapping} = useSeriesStore()
  const {openModal} = useUiStore();

  return (seriesName: string) => {
    const seriesId: string = seriesNameIdMapping[seriesName];
    if (!seriesId) {
      console.error(`Series with name "${seriesName}" not found.`);
      return;
    }
    openModal(
      <SeriesModal seriesId={seriesId}/>,
      {
        className: "md:!p-0 z-[1600]",
        classWrap: "max-w-[62rem] md:rounded-none",
        classButtonClose: "hidden md:block md:absolute md:top-5 md:right-5 dark:fill-n-400",
        classOverlay: "md:bg-n-100",
      }
    );
  }
}